var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white py-8 menucontrol-scroll w-full fixed-top"},[_c('div',{staticClass:"px-6 pb-8"},[(
        _vm.modules.filter(
          (x) =>
            (typeof x == 'object' &&
              ['Admin', 'Developer'].includes(_vm.login.role) &&
              x.extensionId &&
              x.extensionId.name === 'Ecommerce' &&
              x.status === 'Active') ||
            x === 'Ecommerce'
        ).length
      )?_c('EcommerceOption'):_vm._e(),(
        ['Admin', 'Developer'].includes(_vm.login.role) ||
        _vm.modules.filter((x) => x === 'Performance').length
      )?_c('PerformanaceOption'):_vm._e(),(
        ['Admin', 'Developer'].includes(_vm.login.role) ||
        _vm.multiLineArray(_vm.allModules, _vm.userModules)
      )?_c('SettingsOption'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }